import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ChatLink } from "../components/ChatLink";
import { isoWebPageURL } from "../models/nominals";
import { usePageURL } from "../utils/urls";

export const Template = (
    props: Immutable<templates.ChatLinkTemplate>,
): React.JSX.Element => {
    const home = usePageURL("home");

    return (
        <ChatLink
            className={props.class_name || undefined}
            chatOnlineText={props.chat_online_text || undefined}
            chatOfflineText={props.chat_offline_text || undefined}
            chatOfflineLink={
                props.chat_offline_link
                    ? isoWebPageURL.wrap(props.chat_offline_link)
                    : home
            }
            hideIfOffline={props.hide_if_offline}
        />
    );
};
